var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Compressor from 'compressorjs';
// interface Options {
//   maxSizeMB: number; // (default: Number.POSITIVE_INFINITY)
//   maxWidthOrHeight?: number; // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
//   // but, automatically reduce the size to smaller than the maximum Canvas size supported by each browser.
//   // Please check the Caveat part for details.
//   onProgress?: (percentage) => void; // optional, a function takes one progress argument (percentage from 0 to 100)
//   useWebWorker?: boolean; // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
//   signal?: AbortSignal; // options, to abort / cancel the compression
//   // following options are for advanced users
//   maxIteration?: number; // optional, max number of iteration to compress the image (default: 10)
//   exifOrientation?: number; // optional, see https://stackoverflow.com/a/32490603/10395024
//   fileType?: string; // optional, fileType override e.g., 'image/jpeg', 'image/png' (default: file.type)
//   initialQuality?: number; // optional, initial quality value between 0 and 1 (default: 1)
//   alwaysKeepResolution?: boolean; // optional, only reduce quality, always keep width and height (default: false)
// }
// export const comporessImage = async (image: File, options: Options): Promise<File> => {
//   const compressedFile = await imageCompression(image, options);
//   return compressedFile;
// };
export var comporessImage = function (image, options) { return __awaiter(void 0, void 0, Promise, function () {
    var limitSize, DEFAULT_OPTIONS, quality, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                limitSize = 500 * 1024;
                DEFAULT_OPTIONS = {
                    quality: 0.5,
                    checkOrientation: false,
                    convertSize: limitSize,
                    strict: false
                };
                if (options) {
                    throw new Error('EEEE');
                }
                quality = options === null || options === void 0 ? void 0 : options.quality;
                if (!quality) {
                    if (image.size > 5000 * 1024) {
                        // 20mb -> 1.8mb
                        quality = 0.2;
                    }
                    else if (image.size > 2000 * 1024) {
                        // 2.4mb -> 0.4mb
                        quality = 0.3;
                    }
                    else if (image.size > 1000 * 1024) {
                        quality = 0.4;
                    }
                    else if (image.size > limitSize) {
                        quality = 0.5;
                    }
                    else {
                        quality = 0.5;
                    }
                }
                return [4 /*yield*/, compress(image, __assign(__assign(__assign({}, DEFAULT_OPTIONS), options), { quality: quality }))];
            case 1:
                result = (_a.sent());
                return [2 /*return*/, result];
        }
    });
}); };
var compress = function (image, options) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                new Compressor(image, __assign({ success: function (result) {
                        console.log('size', result.size);
                        return resolve(result);
                    }, error: function (err) {
                        console.log('err', err);
                        return reject(err);
                    } }, options));
            })];
    });
}); };
